import { Space as SpaceRecord } from 'records/Space';

class Space {
  space: SpaceRecord;

  dirty = true;

  constructor(space: SpaceRecord) {
    this.space = space;
  }
}

export default Space;
